import { EmptyTableMessage } from "@/core/components/empty-table-message";
import { SimpleTable } from "@/core/components/simple-table";
import { IInternalTransaction } from "@/internal-transactions/InternalTransactions";
import { AmountCol } from "./cols/amount-col";
import { DateInitiatedCol } from "./cols/date-initiated-col";
import { StatusCol } from "./cols/status-col";
import { TypeCol } from "./cols/type-col";

interface InternalTransactionsTableProps {
  data: IInternalTransaction[];
}

const columns = [AmountCol(), DateInitiatedCol(), TypeCol(), StatusCol()];

export const InternalTransactionsTable = ({
  data,
}: InternalTransactionsTableProps) => {
  if (data.length === 0) {
    return <EmptyTableMessage />;
  }

  return (
    <SimpleTable
      columns={columns}
      data={data}
      className="w-full min-w-[600px]"
    />
  );
};
